export default "__VITE_ASSET__CdA4mdWu__"